module.exports = __webpack_public_path__ + "img/c7ae501.jpg";